export function toIDR(value: string): string {
    // Remove any non-digit characters first
    const cleanedValue = value.replace(/[^\d]/g, '');
  
    if (!cleanedValue) return '';
  
    // Convert to number and format
    const numberValue = parseInt(cleanedValue, 10);
  
    return `Rp ${numberValue.toLocaleString('id-ID')}`;
  }